import { render, staticRenderFns } from "./BaseEmptyState.vue?vue&type=template&id=dcf8ef86&scoped=true"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js"
import style0 from "./BaseEmptyState.vue?vue&type=style&index=0&id=dcf8ef86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8ef86",
  null
  
)

export default component.exports